pond_min = 0;



window.recalculateFishCount =    function(){
  fish_counter = 0;
  $('.fish_count').each(function(e){
  	fish_counter += 1;
    $(this).children().first().html(fish_counter);
  });
  if (fish_counter >= pond_min && pond_min > 0){
  	console.log(fish_counter);
  	console.log(pond_min);
  	$("#submit-fish-report-sampling").html("Generar registro");
  	$("#submit-fish-report-sampling").attr("disabled", false);
  }
  else{
  	$("#submit-fish-report-sampling").html("Debe al menos muestrear " + pond_min + " peces y seleccionar un estanque");
  }
}

